import { Injectable, Signal, signal } from '@angular/core';

import { Stand } from '@shared/models';
import { EditMapDeactivateModalService } from '@core/auth/edit-map-deactivate-modal.service';

@Injectable({ providedIn: 'root' })
export class StandSelectionStore {

  constructor(
    readonly editMapService: EditMapDeactivateModalService
  ) {

  }

  private readonly _stands = signal<Stand[]>([]);
  readonly stands: Signal<Stand[]> = this._stands.asReadonly();

  /** Add a stand. No-op if a stand with the same feature.id already exists. */
  add(stand: Stand): void {
    if (!stand) {
      return;
    }
    const current = this._stands();
    if (current.some(s => s.feature.id === stand.feature.id)) {
      return;
    }
    this._stands.set([...current, stand]);
    this.editMapService.dirty = true;
  }

  /** Remove a stand by its feature.id. Missing ids are silently ignored. */
  remove(featureId: string | number): void {
    const current = this._stands();
    const next = current.filter(s => s.feature.id !== featureId);
    if (next.length !== current.length) {
      this._stands.set(next);
      this.editMapService.dirty = true;
    }
  }

  /**
   * Replace the entire selection with hydrated (server-side) data.
   * Resets dirty — this is not a user edit.
   */
  setAll(stands: Stand[]): void {
    this._stands.set(stands ? [...stands] : []);
    this.editMapService.dirty = false;
  }

  /**
   * Replace the entire selection with the result of a user-initiated bulk op
   * (Select-All-Stands, Remove Red-Flag Overlap). Marks dirty=true.
   */
  replaceAll(stands: Stand[]): void {
    this._stands.set(stands ? [...stands] : []);
    this.editMapService.dirty = true;
  }
}
